module.exports = __webpack_public_path__ + "static/media/logo_canacintra@2x.2d5b8f36.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/logo_canacintra@2x.png
// module id = 75
// module chunks = 0